import loadScript from 'load-script';
import DefaultTimeProvider from './datetime';

const timeProvider = new DefaultTimeProvider();
const MAX_RETRIES_DEFAULT = 3;
const RETRY_DELAY_DEFAULT = 500;

export const asyncLoadScript = async (
  url: string,
): Promise<HTMLScriptElement> => await new Promise((resolve, reject) => {
  loadScript(
    url,
    (err: Error | null, script: HTMLScriptElement) => {
      if (err) {
        reject(err);

        return;
      }

      resolve(script);
    },
  );
});

export const loadScriptWithRetries = async (
  url: string,
  maxRetries = MAX_RETRIES_DEFAULT,
  retryDelayMs = RETRY_DELAY_DEFAULT,
): Promise<void> => {
  let retries = 0;

  while (retries < maxRetries) {
    try {
      await asyncLoadScript(url);

      return;
    } catch (error) {
      retries += 1;

      if (retries < maxRetries) {
        await timeProvider.sleepMs(retryDelayMs);
      } else {
        throw error;
      }
    }
  }
};

export const loadScriptWithFallback = async (mainUrl: string, fallbackUrl?: string): Promise<void> => {
  try {
    await loadScriptWithRetries(mainUrl);
  } catch (error) {
    if (!fallbackUrl) {
      throw error;
    }

    await loadScriptWithRetries(fallbackUrl);
  }
};
